import { render, staticRenderFns } from "./Toasts.vue?vue&type=template&id=2a1088c4&scoped=true"
import script from "./Toasts.vue?vue&type=script&lang=ts"
export * from "./Toasts.vue?vue&type=script&lang=ts"
import style0 from "./Toasts.vue?vue&type=style&index=0&id=2a1088c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1088c4",
  null
  
)

export default component.exports